import React from 'react';
import PropTypes from 'prop-types';
import './SectionHeader.css';

/**
 * In-page section title + description + actions (admin tables, tabs).
 * Use PageHeader for top-of-page; SectionHeader for nested panels.
 */
export function SectionHeader({
  title,
  description,
  actions,
  as: TitleTag = 'h2',
  density = 'comfortable',
  className = '',
}) {
  return (
    <div
      className={[
        'onyx-section-header',
        density === 'compact' ? 'onyx-section-header--compact' : '',
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-section-header"
      data-density={density}
    >
      <div className="onyx-section-header__text">
        {title ? (
          <TitleTag className="onyx-section-header__title">{title}</TitleTag>
        ) : null}
        {description ? (
          <p className="onyx-section-header__description">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="onyx-section-header__actions">{actions}</div>
      ) : null}
    </div>
  );
}

SectionHeader.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  actions: PropTypes.node,
  as: PropTypes.elementType,
  density: PropTypes.oneOf(['comfortable', 'compact']),
  className: PropTypes.string,
};

export default SectionHeader;
